module.exports = __webpack_public_path__ + "img/四川天府新区三星中学.0def3c9b.jpg";